module.exports = __webpack_public_path__ + "img/source_main-con01.32a74804.png";